import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { reservaSemPeriodoService } from "../services/reservaSemPeriodoService";

// --------------------- Import Interfaces ---------------------
import { DataTypeReserva } from "../interfaces/DataTypeReserva";

export const useReservaSemPeriodo = () => {
  const [reservaSemPeriodo, setReservasSemPeriodoService] = useState<
    DataTypeReserva[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReservas = async () => {
      const data = await reservaSemPeriodoService();
      setReservasSemPeriodoService(data);
      setIsLoading(false);
    };

    fetchReservas();
  }, []);

  return { reservaSemPeriodo, isLoading };
};
